import * as React from "react";

import { cx } from "class-variance-authority";

import * as theme from "./Table.css";

interface TableProps {
    children: React.ReactNode;
    layoutFixed?: boolean;
    /** Floor for the table's width, so narrow screens scroll instead of squeezing the columns. */
    minWidth?: number;
}
export function Table({ children, layoutFixed, minWidth }: TableProps) {
    return (
        <table
            className={cx(theme.table, layoutFixed && theme.layoutFixed)}
            style={{ minWidth }}
        >
            {children}
        </table>
    );
}
